<template>
  <div class="chat-connect">
    <div class="chat-img animated rubberBand">
      <img src="@/assets/image/kefu2.jpg" alt />
    </div>
    <p class="chat-h2" v-if="item.title" v-html="chatModel.escape(item.title)"></p>
    <p class="chat-h3" v-if="item.desc" v-html="chatModel.escape(item.desc)"></p>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    chatModel: Object
  }
};
</script>

<style lang="stylus">
.chat-connect {
  width: 78%;
  background: #fff;
  text-align: center;
  padding-bottom: 10px;
  border-radius: 10px;
  margin: 60px auto 0;

  .chat-img {
    img {
      width: 65px;
      height: 65px;
      border-radius: 100%;
      border: 5px solid #fff;
      margin-top: -35px;
    }
  }

  .chat-h2 {
    font-size: 1rem;
    font-weight: bolder;
  }

  .chat-h3 {
    font-size: 0.9rem;
    margin-top: 5px;
    padding: 0 7px;

    h1, h2, h3, h4, h5, h6 {
      margin: 8px 0;
      font-weight: bolder;
      line-height: 1.4;
    }

    b {
      font-weight: bolder;
      font-size: 1.2rem;
      margin: 0 1px;
    }
  }
  .blue {
    color: #193a79;
    font-weight: bolder;
    margin: 0 1px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/chatConnect.vue